export const ADDRESS_BOOK_FEATURES = {
    COMPANY_NAME_LABEL: 'COMPANYNAME_LABEL',
    STREET_ADDRESS_LABEL: 'STREET_LABEL',
    SUITE_UNIT_LABEL: 'SUITE_LABEL',
    SUITE_REQUIRED: 'SUITE_REQUIRED',
    CITY_LABEL: 'CITY_LABEL',
    CITY_REQUIRED: 'CITY_REQUIRED',
    STATE_PROVINCE_LABEL: 'STATE_LABEL',
    STATE_REQUIRED: 'STATE_REQUIRED',
    COUNTRY_LABEL: 'COUNTRY_LABEL',
    PHONE_NUMBER_LABEL: 'PHONENO_LABEL',
    PHONE_NUMBER_REQUIRED: 'PHONENO_REQUIRED',
    ZIP_POSTAL_CODE_LABEL: 'ZIPCODE_LABEL',
    DELIVERY_INSTRUCTIONS_LABEL: 'DELINSTRUCTIONS_LABEL',
    DELIVERY_INSTRUCTIONS_REQUIRED: 'DELINSTRUCTIONS_REQUIRED',
    MAIN_CONTACT_NAME_LABEL: 'MAINNAME_LABEL',
    MAIN_CONTACT_NAME_REQUIRED: 'MAINNAME_REQUIRED',
    MAIN_CONTACT_EMAIL_LABEL: 'MAINEMAIL_LABEL',
    MAIN_CONTACT_EMAIL_REQUIRED: 'MAINEMAIL_REQUIRED',
    ADDITIONAL_NAME_LABEL: 'ADDNAME_LABEL',
    ADDITIONAL_NAME_REQUIRED: 'ADDNAME_REQUIRED',
    ADDITIONAL_EMAIL_LABEL: 'ADDEMAIL_LABEL',
    ADDITIONAL_EMAIL_REQUIRED: 'ADDEMAIL_REQUIRED',
    CLIENT_ADDRESS_ID_LABEL: 'CLIENTADDRESSID_LABEL',
    CLIENT_ADDREESS_ID_REQUIRED: 'CLIENTADDRESSID_REQUIRED',
}